import { resolveComponent as _resolveComponent, createVNode as _createVNode, normalizeClass as _normalizeClass, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_base_image_svg = _resolveComponent("base-image-svg")!

  return (_openBlock(), _createElementBlock("div", {
    class: _normalizeClass([
			'hd-mod-frame-flow-chart',
			'js-mod-frame-flow-chart',
			{ 'is-ready': _ctx.ready },
		])
  }, [
    _createVNode(_component_base_image_svg, {
      class: "hd-mod-frame-flow-chart__svg",
      source: require('!html-loader!../../assets/svgs/01-mod-frame-flow-chart.svg')
    }, null, 8, ["source"]),
    _createVNode(_component_base_image_svg, {
      class: "hd-mod-frame-flow-chart__svg hd-mod-frame-flow-chart__svg--mobile",
      source: require('!html-loader!../../assets/svgs/01-mod-frame-flow-chart-mobile.svg')
    }, null, 8, ["source"])
  ], 2))
}